/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../app/hooks';
// import intercomIntegration from '../../../../utils/intercom/intercom-integration';
import { ErrorPayload } from '../../../../interfaces/auth/IErrorPayload';
import { UserPassPayload } from '../../../../interfaces/auth/IUser';
import { useSignInMutation } from '../../../../store/auth/authApi';
// import { useGetWingUserHashMutation } from '../../../../store/user/userApi';
import { tryToAuthorizeUser } from '../../../../store/brokers/partners/partners/partnersSlice';
import { DOMAIN } from '../../../../config';
import ChatHeader from '../../../../shared/chat-header';
import FullLoading from '../../../../shared/full-loading';
import ChatInput from '../../../../shared/chat-bar';


interface ILoginForm {
    onShowHideForgotPassword: () => void;
}

const LoginForm = ({
    onShowHideForgotPassword
}: ILoginForm) => {
    const dispatch = useAppDispatch()
    const { register, handleSubmit, formState: { errors } } = useForm<UserPassPayload>();
    const [signInMutation, { isLoading, error }] = useSignInMutation();
    const [showRedirecting, setShowRedirecting] = useState<boolean>(false)
    const [chatData, setChatData] = useState<any>([]);
    const [chatId, setChatId] = useState<string>();
    const [errorAuthorize, setErrorAuthorize] = useState<string>()

    const navigate = useNavigate();
    let errorMsg: any

    const onGettingChatData = async (newChatData?: any) => {
        try {
            const formData = {
                chatId: chatId,
                chatData: newChatData || chatData || []
            }
            const { data } = await signInMutation(formData).unwrap();
            if (data?.metadata.accessToken) {
                setChatData(data?.chatData)
                setShowRedirecting(true)
                const roles = data?.metadata?.tokenPayload['cognito:groups'];

                localStorage.setItem('accessToken', data?.metadata?.accessToken);
                localStorage.setItem('refreshToken', data?.metadata?.refreshToken);
                localStorage.setItem('cgToken', data?.metadata?.accessToken || '');
                localStorage.setItem('roles', roles?.[0] || '');
                localStorage.setItem('user', data?.metadata?.user?.username);

                navigate(roles?.[0] === 'admins' ? '/insights' : '/insights');
            }
            setShowRedirecting(false)
            setChatData(data?.chatData)
            setChatId(data?.metadata?.chatId)
        } catch (err: any) {
            console.error(err)
            errorMsg = err?.data?.message
        }
    }

    useEffect(() => {
        onGettingChatData()
    }, [])

    const err = { ...error as ErrorPayload };
    errorMsg = err.status === 401 ? 'Username or password are incorrect' : 'Something went wrong'
    return (
        <div className='!rounded-xl bg-[#f5f5f5] p-0'>
            <ChatHeader />
            <div className='p-3'>
                {(!!err.data || errorAuthorize) && <div className='p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800' role='alert'>
                    <span className='font-medium'> {errorAuthorize || err.data.message || errorMsg} </span>
                </div>}
                <ChatInput
                    chatData={chatData}
                    onGettingChatData={onGettingChatData}
                />
            </div>
            {showRedirecting && <FullLoading />}
        </div>
    )
}

export default LoginForm;